import React from "react";
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";

// The canonical set (text + Bootstrap color variant)
export const STATUS_OPTS = [
    { id: "open", text: "Open", color: "success" },
    { id: "pending", text: "Pending", color: "warning" },
    { id: "on_hold", text: "On Hold", color: "secondary" },
    { id: "closed", text: "Closed", color: "dark" },
];

// Soften only the fill (keeps text/caret crisp)
const softFill = (variant, alpha = 0.2) => {
    const hex = {
        success: "#198754",
        warning: "#ffc107",
        secondary: "#6c757d",
        dark: "#343a40",
    }[variant] || "#6c757d";

    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const bg = `rgba(${r},${g},${b},${alpha})`;
    return { backgroundColor: bg, borderColor: bg };
};

/**
 * Props:
 *  - value:     current status id ("open" | "pending" | "on_hold" | "closed")
 *  - onChange:  (nextId) => void
 *  - stopClickPropagation: default true (useful inside clickable list rows)
 *  - alpha:     background alpha (0..1), default .7 for strong pills
 */
export default function StatusPill({
    value,
    onChange,
    stopClickPropagation = true,
    alpha = 0.7,
    disabled = false
}) {
    const cur = String(value ?? "").toLowerCase();
    const opt = STATUS_OPTS.find(o => o.id === cur) ?? STATUS_OPTS[0];

    const stop = (e) => { if (stopClickPropagation) e.stopPropagation(); };

    if (disabled) {
        // Non-interactive lookalike
        return (
            <div onClick={stop} title="Archived">
                <div
                    className="rounded-pill py-0 px-2"
                    style={{ lineHeight: "22px", opacity: 0.55, pointerEvents: "none", ...softFill(opt.color, alpha) }}
                >
                    <small className="fw-semibold text-capitalize">{opt.text}</small>
                </div>
            </div>
        );
    }

    return (
        <div onClick={stop}>
            <UncontrolledDropdown>
                <DropdownToggle
                    caret
                    color={opt.color}
                    className="rounded-pill py-0 px-2"
                    style={{ lineHeight: "22px", ...softFill(opt.color, alpha) }}
                >
                    <small className="fw-semibold text-capitalize">{opt.text}</small>
                </DropdownToggle>
                <DropdownMenu
                    container="body"
                    style={{ zIndex: 2000 }}
                    modifiers={[{ name: "preventOverflow", options: { boundary: "viewport", padding: 8 } }]}
                >
                    {STATUS_OPTS.map(o => (
                        <DropdownItem
                            key={o.id}
                            active={o.id === opt.id}
                            onClick={(e) => { e.preventDefault(); stop(e); onChange?.(o.id); }}
                        >
                            {o.text}
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </UncontrolledDropdown>
        </div>
    );
}
